export { AWSS3Provider } from './AWSS3Provider';
